import type {
	BannerPiece,
	CollectionGridPiece,
	ComponentChoiceComponentForLandingPageBlocks,
	FaqPiece,
	ImageTileCtaPiece,
	InstagramFeedPiece,
	StoreinfoPiece,
	TestimonialsPiece,
	TextPiece,
} from "@workspace/crystallize/generated/discovery/";

export type LandingBlockTagged =
	| { kind: "banner"; data: BannerPiece }
	| { kind: "collectionGrid"; data: CollectionGridPiece }
	| { kind: "faq"; data: FaqPiece }
	| { kind: "imageTileCta"; data: ImageTileCtaPiece }
	| { kind: "testimonials"; data: TestimonialsPiece }
	| { kind: "text"; data: TextPiece }
	| { kind: "storeinfo"; data: StoreinfoPiece }
	| { kind: "instagramFeed"; data: InstagramFeedPiece };

export function toTaggedBlock(
	b: ComponentChoiceComponentForLandingPageBlocks,
): LandingBlockTagged | null {
	if (b.banner) return { kind: "banner", data: b.banner };
	if (b.imageTileCta) return { kind: "imageTileCta", data: b.imageTileCta };
	if (b.collectionGrid)
		return { kind: "collectionGrid", data: b.collectionGrid };
	if (b.faq) return { kind: "faq", data: b.faq };
	if (b.testimonials) return { kind: "testimonials", data: b.testimonials };
	if (b.text) return { kind: "text", data: b.text };
	if (b.storeinfo) return { kind: "storeinfo", data: b.storeinfo };
	if (b.instagramFeed) return { kind: "instagramFeed", data: b.instagramFeed };
	return null;
}
